import { ROLES_LIST } from '@/js/constants';
export default [{
  name: 'Assessment Report',
  key: 'menu.asset_governance_sub.reports',
  subname: '',
  href: {
    name: 'asset_governance_reports'
  },
  link: '/asset-governance/reports',
  roles: []
}, {
  name: 'Assessment Report',
  key: 'menu.asset_governance_sub.maintenance',
  subname: '',
  href: {
    name: 'asset_governance_maintenance'
  },
  link: '/asset-governance/maintenance',
  roles: [ROLES_LIST.ORG_DATA_STEWARD],
  checkDomain: true
}];